import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }) => ({
  activeLabel: {
    color: palette.common.black,
  },
  activeStrong: {
    color: palette.primary.main,
  },
}));
